import React from 'react';

import { Navigate, useLocation, useNavigate, useRoutes } from 'react-router-dom';
import Creator from './pages/admin/Creator';
import LibraryEditor from './pages/admin/LibraryEditor';
import Dashboard from './pages/dashboard';
import DialogDetail from './pages/dialog-detail';
import Editor from './pages/editor';
import QuestionForm from './pages/form';
import SuccessPage from './pages/form/SuccessPage';
import NotFound from './pages/notfound';
import { toast } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import jwt, { decode } from 'jsonwebtoken';
import Auth from './pages/admin/Auth';
import Moderation from './pages/admin/Moderation';
import ModerationEdit from './pages/admin/ModerationEdit';
import Home from './pages/admin/Home';
import Information from './pages/dashboard/Information';
import DocumentPDF from './pages/dashboard/DocumentPDF';
import User from './pages/admin/User';
import { isMenuEligible } from './helpers/eligibilityChecker';
import Page403 from './pages/admin/Page403';
import ModerationReview from './pages/admin/ModerationReview';
import NotificationPage from './pages/admin/NotificationPage';
import ModerationPreview from './pages/admin/ModerationPreview';
import Content from './pages/public/Content';
import PublicIndex from './pages/public/PublicIndex';
import MyRepositories from './pages/portal/MyRepositories';
import UserEdit from './pages/admin/UserEdit';
import RepositoryIDBridge from './pages/portal/RepositoryIDBridge';
import RegisterPage from './pages/register/RegisterPage';
import CheckRegistrationStatus from './pages/register/CheckRegistrationStatus';
import RegistrationSuccessPage from './pages/register/RegistrationSuccessPage';
import Registrations from './pages/portal/Registrations';
import RegistrationDetail from './pages/portal/RegistrationDetail';
import RegisterPageV2 from './pages/register/RegisterPageV2';

// ----------------------------------------------------------------------

export default function Router() {
  const location = useLocation();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const [userInfo, setUserInfo] = React.useState({});

  React.useEffect(() => {
    if (cookies.get('token')) {
      const decoded = jwt.decode(cookies.get('token'));

      const userType = decoded.type;
      if (isMenuEligible(userType, location)) return setUserInfo({ ...userInfo, ...decoded });
      navigate('/noaccess');
    } else {
      const locationSplit = location.pathname.split('/');
      if (['admin-dev-phase', 'admin', 'portal', 'form'].includes(locationSplit[1])) {
        navigate('/auth');
        // navigate(
        //   ['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE) ? '/' : '/',
        //   'replace'
        // );
        // alert(`test ${locationSplit[1]}`);
      }
      // setUser({});
    }
  }, [location.pathname]);

  return useRoutes([
    {
      path: '/',
      element: <Dashboard userInfo={userInfo} />,
    },
    {
      path: 'auth',
      element: <Auth />,
    },
    {
      path: 'noaccess',
      element: <Page403 />,
    },
    {
      path: 'dialog-detail',
      element: <DialogDetail />,
    },
    {
      path: 'register',
      element: <RegisterPageV2 />,
    },
    {
      path: 'register/check',
      element: <CheckRegistrationStatus />,
    },
    {
      path: 'register/success',
      element: <RegistrationSuccessPage />,
    },
    {
      path: 'how-to-use-this-web',
      element: <Information />,
    },
    {
      path: 'document-pdf/:id',
      element: <DocumentPDF userInfo={userInfo} />,
    },
    {
      path: 'portal',
      children: [
        { index: true, element: <Home userInfo={userInfo} /> },
        { path: 'moderation', element: <Moderation userInfo={userInfo} /> },
        { path: 'moderation/detail', element: <ModerationEdit userInfo={userInfo} /> },
        { path: 'moderation/detail/success', element: <SuccessPage userInfo={userInfo} /> },
        { path: 'moderation/preview/:id', element: <ModerationPreview userInfo={userInfo} /> },
        { path: 'moderation/review/:id', element: <ModerationReview userInfo={userInfo} /> },
        { path: 'moderation/review/success', element: <SuccessPage userInfo={userInfo} /> },
        { path: 'my-repositories', element: <MyRepositories userInfo={userInfo} /> },
        { path: 'my-repositories/review/:id', element: <ModerationReview userInfo={userInfo} /> },
        { path: 'my-repositories/edit', element: <ModerationEdit userInfo={userInfo} /> },
        { path: 'repository-bridge/:id', element: <RepositoryIDBridge userInfo={userInfo} /> },
        { path: 'creator', element: <Creator userInfo={userInfo} /> },
        { path: 'my-profile/:id', element: <UserEdit userInfo={userInfo} /> },
        { path: 'users', element: <User userInfo={userInfo} /> },
        { path: 'users/:id', element: <UserEdit userInfo={userInfo} /> },
        { path: 'notifications', element: <NotificationPage userInfo={userInfo} /> },
        { path: 'notifications/:id', element: <ModerationReview userInfo={userInfo} /> },
        { path: 'notifications/detail', element: <ModerationEdit userInfo={userInfo} /> },
        { path: 'creator/library-editor', element: <LibraryEditor userInfo={userInfo} /> },
        { path: 'registrations', element: <Registrations userInfo={userInfo} /> },
        { path: 'registrations/:id', element: <RegistrationDetail userInfo={userInfo} /> },
      ],
    },
    {
      path: 'public',
      children: [
        { path: ':id', element: <PublicIndex userInfo={userInfo} /> },
        { path: 'printonly/:id', element: <Content userInfo={userInfo} /> },
      ],
    },
    {
      path: 'form',
      children: [
        { index: true, element: <QuestionForm userInfo={userInfo} /> },
        { path: 'success', element: <SuccessPage userInfo={userInfo} /> },
      ],
    },
    {
      path: '404',
      element: <NotFound />,
    },
    { path: '*', element: <Navigate to='/404' replace /> },
    { path: 'information', element: <Navigate to='/how-to-use-this-web' replace /> },
  ]);
}
